"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTestnet = exports.getNetworkNameforNetworkId = exports.isSupportedNetwork = exports.NETWORK_IDS = exports.NETWORK_NAMES = exports.SUPPORTED_NETWORKS_ARRAY = void 0;
/**
 * @WARN matic is not "supported" as the only place that it works is on nft
 *       analytics, and therefore also our shopify token gating widget
 *       (because it uses nft analytics for data). Wwe can add it back in
 *       once studio client and contract deployer etc support it.
 *
 */
exports.SUPPORTED_NETWORKS_ARRAY = [1, 10, 137, 8453, 11155111];
var NETWORK_NAMES;
(function (NETWORK_NAMES) {
    NETWORK_NAMES["MAINNET"] = "mainnet";
    NETWORK_NAMES["GOERLI"] = "goerli";
    NETWORK_NAMES["OPTIMISM"] = "optimism";
    NETWORK_NAMES["BASE"] = "base";
    NETWORK_NAMES["SEPOLIA"] = "sepolia";
    NETWORK_NAMES["MATIC"] = "matic";
})(NETWORK_NAMES || (exports.NETWORK_NAMES = NETWORK_NAMES = {}));
var NETWORK_IDS;
(function (NETWORK_IDS) {
    NETWORK_IDS[NETWORK_IDS["MAINNET"] = 1] = "MAINNET";
    NETWORK_IDS[NETWORK_IDS["GOERLI"] = 5] = "GOERLI";
    NETWORK_IDS[NETWORK_IDS["OPTIMISM"] = 10] = "OPTIMISM";
    NETWORK_IDS[NETWORK_IDS["BASE"] = 8453] = "BASE";
    NETWORK_IDS[NETWORK_IDS["SEPOLIA"] = 11155111] = "SEPOLIA";
    NETWORK_IDS[NETWORK_IDS["MATIC"] = 137] = "MATIC";
})(NETWORK_IDS || (exports.NETWORK_IDS = NETWORK_IDS = {}));
/**
 * Checks if a given network id is supported by the app.
 * @param x the network id to check
 * @returns true if the network id is supported, false otherwise
 * @see SUPPORTED_NETWORKS_ARRAY
 */
const isSupportedNetwork = (x) => {
    return exports.SUPPORTED_NETWORKS_ARRAY.includes(x);
};
exports.isSupportedNetwork = isSupportedNetwork;
/**
 * Returns the network name for a given network id.
 * @param networkId the network id to get the name for
 * @returns the network name, all lower case
 * @throws if the network id is not supported
 */
function getNetworkNameforNetworkId(networkId) {
    switch (networkId) {
        case NETWORK_IDS.GOERLI:
            return NETWORK_NAMES.GOERLI;
        case NETWORK_IDS.SEPOLIA:
            return NETWORK_NAMES.SEPOLIA;
        case NETWORK_IDS.OPTIMISM:
            return NETWORK_NAMES.OPTIMISM;
        case NETWORK_IDS.BASE:
            return NETWORK_NAMES.BASE;
        case NETWORK_IDS.MAINNET:
            return NETWORK_NAMES.MAINNET;
        case NETWORK_IDS.MATIC:
            return NETWORK_NAMES.MATIC;
        default:
            throw new Error('Unsupported Network');
    }
}
exports.getNetworkNameforNetworkId = getNetworkNameforNetworkId;
/**
 * A simple check to see if the network is a testnet by specifically
 * testing if it is NOT one of the known mainnets (1, 10, 8453, 137).
 *
 * @param networkId the network id to check
 * @returns true if the network is a testnet, false otherwise
 */
function isTestnet(networkId) {
    return networkId !== 1 && networkId !== 10 && networkId !== 8453 && networkId !== 137;
}
exports.isTestnet = isTestnet;
//# sourceMappingURL=network.js.map